const COPYRIGHT_YEAR = new Date().getFullYear();

export function AppFooter() {
  return (
    <footer className="footer">
      Ironfleet CRM · © {COPYRIGHT_YEAR} Ironfleet Aero Inc.
    </footer>
  );
}
